const enTranslations = {
  home: 'Home',
  collections: 'Collections',
  developers: 'Developers',
  organization: 'Organization',
  profile: 'Profile',
  logout: 'Logout',
  search: 'Search..',

  allCaughtUp: "You're all caught up!",
  noNotif: 'No new notifications available',

  // Login and register screens
  newUser: 'New user?',
  createAccount: 'Create an account',
  alreadyAccount: 'Have an account?',
  register: 'Register',
  email: 'Email',
  password: 'Password',
  login: 'Login',
  loginAccount: 'Login to your account',
  listOfProducts: 'List of products',
  viewDeveloper: 'View developer info',
  firstName: 'First name',
  lastName: 'Last name',
  confirmPassword: 'Confirm password',

  // Sidebar
  products: 'Products',
  categories: 'Categories',
  analytics: 'Analytics',
  createCategory: 'Create new collection',

  // Products list page
  view: 'View',
  edit: 'Edit',
  delete: 'Delete',
  publishedOn: 'Published on',

  // Error screens
  errUserdet: 'Error fetching user details',
  errNetworkLogin: 'This could be a network issue or you are logged in incorrectly',

  sort: 'Sort',
  show: 'Show',
  recentModified: 'Recently modified',
  all: 'All',
  enabled: 'Enabled',
  disabled: 'Disabled',
  enable: 'Enable',
  disable: 'Disable',
  createNewProduct: 'Create new product',
  productsSelected: 'products selected',
  selectAll: 'Select all',
  cancel: 'Cancel',
  bulkActions: 'Bulk actions',

  copyLink: 'Copy link',
  unpublish: 'Unpublish',
  annotation: 'Annotation',
  details: 'Details',
  name: 'Name',
  description: 'Description',
  annotations: 'Annotations',
  addAnnotation: 'Add annotation',
  clickAddAnnotation: 'Click on a point to add annotation',
  annoName: 'Annotation name',
  content: 'Content',
  dailyViewsPastWeek: 'Daily views for the past week',
  preview: 'Preview',
  backProducts: 'Back to list of products',
  backCategories: 'Back to list of categories',
  viewsCategory: 'Product views by category',
  mostViewProducts: 'Most viewed products',
  confirm: 'Confirm',
  noDescription: 'No description available',
  noAnnotations: 'No annotations available',

  productOptions: 'Product options',
  noProductOptions: 'No product options available',
  variant: 'Variant',
  color: 'Color',
  unnamedAnnotation: 'Unnamed annotation',

  users: 'Users',
  billing: 'Billing',
  invoices: 'Invoices',
  settings: 'Settings',
  addUser: 'Add user',
  admin: 'Admin',
  manager: 'Manager',
  viewer: 'Viewer',
  editor: 'Editor',
  role: 'Role',
  currentUsage: 'Current usage',
  paymentInformation: 'Payment information',
  noPaymentAdded: 'No payment methods added',
  noPastInvoices: 'No past invoices',
  notifyNewInvoices: 'We will notify you for new invoices generated.',
  companyName: 'Company name',
  contactEmail: 'Contact email',

  actions: 'Actions',
  editProfile: 'Edit Profile',
  updatePassword: 'Update password',
  deactivateAcc: 'Deactivate account',
  currentPass: 'Current password',
  newPass: 'New password',
  confirmNewPass: 'Confirm new password',
  update: 'Update',
  passnoMatch: "Passwords don't match. Please check again",

  overview: 'Overview',
  productViews: 'Product views',
  newVis: 'New visitors',
  mostViewedProd: 'Most viewed products',

  pageView: 'Page views',
  devices: 'Devices',
  os: 'Operating system',
  utra: 'User tracking',
  loca: 'Location',
  unknown: 'Unknown',
  direct: 'Direct traffic',
  none: 'None',
  referral: 'Referral',
  mac: 'Mac',
  iOS: 'iOS',
  Android: 'Android',
  other: 'Other',
  Windows: 'Windows',

  'Asia/Calcutta': 'India',
  'Asia/Tokyo': 'Japan',
  PST8PDT: 'Western US and Canada',
  'Asia/Riyadh': 'Saudi Arabia',
  'America/Los_Angeles': 'Western US',

  dev: {
    dg: 'Developer guide',
    gs: 'Getting started',
    em: 'Embedding the preview is easy. Just add the below iframe code wherever you want to display the viewer on your page.',
    df: "Don't forget to replace ***product_id*** with the ID for your product.",
    af: 'A few notes: ',
    sr: 'src: ',
    rp: "Don't forget to replace ***product_id*** with the ID for your product.",
    sz: 'Size: ',
    if: 'You can adjust the iframe size with CSS like you would for any other element. The 3D viewer always resizes to fill the contents of iframe.',
    at: `"allowfullscreen" attribute: `,
    ab: "In the absense of this attribute, the viewer doesn't show a fullscreen button. When present, it shows the button only if the browser supports it. You could still control whether the button is shown outside an iframe with `no_fullscreen` url option",
    pg: 'Playground',

    ls: 'To make your life simpler, we created a playground interface. Adjust the options to see a realtime preview with the corresponding code to embed it.',
    de: 'A more detailed explanation of the options is available in the next section.',

    co: 'Code for the above options:',
    cp: 'Copy to clipboard',

    cop: 'Configuration options',
    vb: "The 3D viewer's behavior can be controlled with url parameters. We choose the most widely set value as default for all options. If you'd like to have an option for additional customization, please reach out to us and we shall look into it.",
    lo: 'List of all the available options:',

    sp: 'Support',
    wt: 'We try our best to keep the tech as simple as possible.',
    hi: 'If you need help integrating the embed, have suggestions for improvement, or want to report a bug, please feel free to reach out to us at hello@euclidxr.com',

    yes: 'YES',
    no: 'NO',

    pi: 'Product ID',
    bc: 'Background color',
    th: 'Theme',
    da: 'dark',
    l: 'light',
    st: 'Load on start',
    po: 'Show poster',
    ro: 'Auto rotate',
    ar: 'AR available',
    hp: 'Hide prompt',
    ai: 'Allow interaction',
    fl: 'Allow fullscreen',
    ho: 'Hide options',
    la: 'Language',

    op: 'Option',
    dl: 'Default',
    dt: 'Details',
    opb: 'Background color of the interface. Currently, this only supports a hex value (#RRGGBB). Do note that this does not change the text color. So if the text contrast is low and legibility is difficult, try changing the theme option.',
    opw: 'When enabled, shows a button to let the user to manually click to load the 3D model. Useful while displaying multiple 3D models in a single page.',
    opi: 'Whether to show an image of the 3D model while the actual model file loading is in progress.',
    ops: `Set to "dark" to adjust text color for better contrast on darker backgrounds.`,
    opc: 'Continuously rotates the model in 360 deg.',
    opr: 'Rotation speed in deg/sec. Only works when autorotate is set.',
    opo: 'Setting this option prevents the user from interacting with the 3D viewer with mouse/touch.',
    opp: 'Prevent user from viewing the 3D model in fullscreen.',
    oph: 'Hides the options panel.',
    opv: `Hides the "View in your space" button for all the devices even though they support AR.`,
  },
};

export default enTranslations;
